import { useState } from "react";
import { toast } from "sonner";
import { adminLogin, setToken, errText } from "@/lib/api";
import { inputCls, goldBtnCls } from "./constants";

export const Login = ({ onLogin }) => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const res = await adminLogin(email, password);
      setToken(res.access_token);
      onLogin();
    } catch (err) {
      toast.error(errText(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="grain-dark flex min-h-[70vh] items-center justify-center bg-onyx px-4 py-20 text-cream">
      <form onSubmit={submit} className="gold-frame relative w-full max-w-md bg-charcoal p-8" data-testid="admin-login-form">
        <div className="pointer-events-none absolute inset-2 border border-gold/15" />
        <span className="absolute -top-4 right-6 -rotate-3 border border-gold/50 bg-onyx px-2.5 py-0.5 font-marker text-lg text-goldlight">staff only!!</span>
        <div className="relative">
          <p className="font-cinzel text-[10px] uppercase tracking-[0.4em] text-gold">Restricted access</p>
          <h1 className="mt-3 font-display text-4xl uppercase tracking-tight text-metallic">The Inbox</h1>
          <p className="mt-1 font-body text-sm text-silver/70">Submissions inbox — Village staff only.</p>
          <div className="mt-6 space-y-4">
            <input type="email" required placeholder="Email" value={email} onChange={(e) => setEmail(e.target.value)} data-testid="admin-email-input" className={"w-full " + inputCls} />
            <input type="password" required placeholder="Password" value={password} onChange={(e) => setPassword(e.target.value)} data-testid="admin-password-input" className={"w-full " + inputCls} />
          </div>
          <button type="submit" disabled={loading} data-testid="admin-login-btn" className={goldBtnCls + " mt-6 w-full py-3 text-sm tracking-[0.15em]"}>
            {loading ? "Opening..." : "Open the Inbox"}
          </button>
        </div>
      </form>
    </div>
  );
};
